// IdP-Hint aus der URL (Magic-Link / Support-Login, TQ #812).
//
// Akzeptiert `?idp=<alias>` (bisheriger Parametername) und `?kc_idp_hint=<alias>` (Name, den Keycloak selbst
// benutzt, damit ein Support-Link wie https://cockpit.it-sce.de/<kennung>/?kc_idp_hint=it-sce funktioniert).
// `idp` gewinnt, wenn beide gesetzt sind. Leere Werte und Werte mit Zeichen ausserhalb eines IdP-Alias
// (Buchstaben, Ziffern, `-`, `_`, `.`; max. 64) werden verworfen: der Wert landet in der Keycloak-Auth-URL.
const ALIAS_RE = /^[A-Za-z0-9._-]{1,64}$/

export function idpHintFromSearch(search: string): string | undefined {
  const params = new URLSearchParams(search)
  for (const key of ['idp', 'kc_idp_hint']) {
    const v = params.get(key)?.trim()
    if (v && ALIAS_RE.test(v)) return v
  }
  return undefined
}
